import React from 'react';

export const ChevronDownIcon = ({ color = 'var(--main-color)' }) => (
    <svg
        className="chevron-down-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M18 9L12 15L6 9" stroke={color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const ChevronDownThickIcon = ({ color = '#2D7876', className }) => (
    <svg
        className={className}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M18 9L12 15L6 9" stroke={color} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const ChevronLeftIcon = () => (
    <svg
        data-testid="chveron-left__icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10.4141 11.9998L14.0001 15.5858C14.3911 15.9768 14.3911 16.6098 14.0001 16.9998C13.6091 17.3908 12.9761 17.3908 12.5861 16.9998L9.00006 13.4138C8.21906 12.6328 8.21906 11.3668 9.00006 10.5858L12.5861 6.99979C12.9761 6.60879 13.6091 6.60879 14.0001 6.99979C14.3911 7.39079 14.3911 8.02379 14.0001 8.41379L10.4141 11.9998Z"
            fill="#6B6B6B"
        />
    </svg>
);

export const ChevronRightIcon = ({ fill = '#686868' }) => (
    <svg
        data-testid="chevron-right__icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M13.5859 11.9998L9.99991 15.5858C9.60991 15.9758 9.60991 16.6088 9.99991 16.9998C10.3899 17.3908 11.0239 17.3908 11.4139 16.9998L14.9999 13.4138C15.7809 12.6328 15.7809 11.3668 14.9999 10.5858L11.4149 6.99979C11.0239 6.60879 10.3909 6.60879 9.99991 6.99979C9.60891 7.39079 9.60991 8.02379 9.99991 8.41379L13.5859 11.9998Z"
            fill={fill}
        />
    </svg>
);

export const ResetIcon = ({ color, size = 24, onClick }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
    >
        <path d="M14 15L10 19L14 23" stroke={color} strokeWidth="2" />
        <path
            d="M5.93782 15.5C5.16735 14.1655 4.85875 12.6141 5.05989 11.0863C5.26102 9.55856 5.96064 8.13986 7.05025 7.05025C8.13986 5.96064 9.55856 5.26102 11.0863 5.05989C12.6141 4.85875 14.1655 5.16735 15.5 5.93782C16.8345 6.70829 17.8775 7.89757 18.4672 9.32122C19.0568 10.7449 19.1603 12.3233 18.7615 13.8117C18.3627 15.3002 17.4838 16.6154 16.2613 17.5535C15.0388 18.4915 13.5409 19 12 19"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
);

export const CloseIcon = ({ color = '#000000', onClick, strokeWidth = 2.5 }) => (
    <svg
        data-testid="close-icon__global"
        onClick={onClick}
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M18 6L6 18" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth={strokeWidth} />
        <path d="M6 6L18 18" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth={strokeWidth} />
    </svg>
);

export const SortIcon = ({ color, size = '24' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8 20L7.29289 20.7071L8 21.4142L8.70711 20.7071L8 20ZM14 5C14.5523 5 15 4.55228 15 4C15 3.44772 14.5523 3 14 3L14 5ZM3.29289 16.7071L7.29289 20.7071L8.70711 19.2929L4.70711 15.2929L3.29289 16.7071ZM8.70711 20.7071L12.7071 16.7071L11.2929 15.2929L7.29289 19.2929L8.70711 20.7071ZM9 20L9 8L7 8L7 20L9 20ZM12 5L14 5L14 3L12 3L12 5ZM9 8C9 6.34315 10.3431 5 12 5L12 3C9.23858 3 7 5.23858 7 8L9 8Z"
            fill={color}
        />
        <path
            d="M16 10L15.2929 9.29289L16 8.58579L16.7071 9.29289L16 10ZM16 18L17 18L16 18ZM14 21C13.4477 21 13 20.5523 13 20C13 19.4477 13.4477 19 14 19L14 21ZM11.2929 13.2929L15.2929 9.29289L16.7071 10.7071L12.7071 14.7071L11.2929 13.2929ZM16.7071 9.29289L20.7071 13.2929L19.2929 14.7071L15.2929 10.7071L16.7071 9.29289ZM17 10L17 18L15 18L15 10L17 10ZM17 18C17 19.6569 15.6569 21 14 21L14 19C14.5523 19 15 18.5523 15 18L17 18Z"
            fill={color}
        />
    </svg>
);

export const FilterIcon = ({ color }) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 2C4.44772 2 4 2.44772 4 3V5.00001H20V3C20 2.44772 19.5523 2 19 2H5ZM19.7822 7.00001H4.21776C4.3321 7.22455 4.48907 7.42794 4.68299 7.59762L10.683 12.8476C11.437 13.5074 12.563 13.5074 13.317 12.8476L19.317 7.59762C19.5109 7.42794 19.6679 7.22455 19.7822 7.00001Z"
            fill={color}
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M14 16.7049L14 10H10V18.7049L14 16.7049Z" fill={color} />
    </svg>
);

export const CalendarIcon = ({ color }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3 10C3 8.11438 3 7.17157 3.58579 6.58579C4.17157 6 5.11438 6 7 6H17C18.8856 6 19.8284 6 20.4142 6.58579C21 7.17157 21 8.11438 21 10H3Z"
            fill="#7E869E"
            fillOpacity="0.25"
        />
        <rect x="3" y="6" width="18" height="15" rx="2" stroke={color} strokeWidth="1.2" />
        <path d="M7 3L7 6" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
        <path d="M17 3L17 6" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
        <rect x="7" y="12" width="4" height="2" rx="0.5" fill={color} />
        <rect x="7" y="16" width="4" height="2" rx="0.5" fill={color} />
        <rect x="13" y="12" width="4" height="2" rx="0.5" fill={color} />
        <rect x="13" y="16" width="4" height="2" rx="0.5" fill={color} />
    </svg>
);

export const IconAdditional = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
        <path
            fill="#2D2D2D"
            d="M14.4 24.4a2 2 0 114 0 2 2 0 01-4 0zm0-8a2 2 0 114 0 2 2 0 01-4 0zm0-8a2 2 0 114 0 2 2 0 01-4 0z"
        ></path>
    </svg>
);

export const OpenEyeIcon = ({ onClick, color = '#4D4D4D' }) => (
    <svg
        data-testid="open-eye-icon"
        id="open-eye-icon"
        className="eye-icon"
        onClick={onClick}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10 7.5C9.33831 7.50437 8.70496 7.76916 8.23706 8.23706C7.76916 8.70496 7.50437 9.33831 7.5 10C7.5 11.3683 8.63167 12.5 10 12.5C11.3675 12.5 12.5 11.3683 12.5 10C12.5 8.6325 11.3675 7.5 10 7.5Z"
            fill={color}
        />
        <path
            d="M10 4.16669C3.6392 4.16669 1.72754 9.68085 1.71004 9.73669L1.6217 10L1.7092 10.2634C1.72754 10.3192 3.6392 15.8334 10 15.8334C16.3609 15.8334 18.2725 10.3192 18.29 10.2634L18.3784 10L18.2909 9.73669C18.2725 9.68085 16.3609 4.16669 10 4.16669ZM10 14.1667C5.54087 14.1667 3.81337 10.9617 3.39504 10C3.81504 9.03502 5.54337 5.83335 10 5.83335C14.4592 5.83335 16.1867 9.03835 16.605 10C16.185 10.965 14.4567 14.1667 10 14.1667Z"
            fill={color}
        />
    </svg>
);

export const CloseEyeIcon = ({ onClick }) => (
    <svg
        data-testid="close-eye-icon"
        className="eye-icon"
        onClick={onClick}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2 5.33337C2.21157 5.73981 2.53215 6.11684 2.94092 6.45184C4.087 7.39114 5.92633 8.00004 8 8.00004C10.0737 8.00004 11.913 7.39114 13.0591 6.45184C13.4678 6.11684 13.7884 5.73981 14 5.33337"
            stroke="#2A3D4A"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M9.65918 8L10.3493 10.5758L9.65918 8Z" fill="#2A3D4A" />
        <path d="M9.65918 8L10.3493 10.5758" stroke="#2A3D4A" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.4512 7.11792L14.3368 9.00352" stroke="#2A3D4A" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.66669 9.00343L3.55231 7.1178" stroke="#2A3D4A" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.64258 10.5758L6.33275 8" stroke="#2A3D4A" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const SettingIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse
            cx="7"
            cy="7"
            rx="3"
            ry="3"
            transform="rotate(90 7 7)"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <path
            d="M9.5 5H18C19.1046 5 20 5.89543 20 7V7C20 8.10457 19.1046 9 18 9H9.5"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <ellipse
            cx="3"
            cy="3"
            rx="3"
            ry="3"
            transform="matrix(4.37114e-08 1 1 -4.37114e-08 14 14)"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <path
            d="M14.5 15H6C4.89543 15 4 15.8954 4 17V17C4 18.1046 4.89543 19 6 19H14.5"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
);
export const MenuIcon = ({ color = '#CCD2E3' }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 7H19" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <path d="M5 12H19" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <path d="M5 17H19" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export const DeleteIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 15L10 12" stroke="#f27373" strokeWidth="1.2" strokeLinecap="round" />
        <path d="M14 15L14 12" stroke="#f27373" strokeWidth="1.2" strokeLinecap="round" />
        <path
            d="M3 7H21C20.0681 7 19.6022 7 19.2346 7.15224C18.7446 7.35523 18.3552 7.74458 18.1522 8.23463C18 8.60218 18 9.06812 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16V10C6 9.06812 6 8.60218 5.84776 8.23463C5.64477 7.74458 5.25542 7.35523 4.76537 7.15224C4.39782 7 3.93188 7 3 7Z"
            fill="#f27373"
            fillOpacity="0.25"
            stroke="#f27373 "
            strokeWidth="1.2"
            strokeLinecap="round"
        />
        <path
            d="M10.0681 3.37059C10.1821 3.26427 10.4332 3.17033 10.7825 3.10332C11.1318 3.03632 11.5597 3 12 3C12.4403 3 12.8682 3.03632 13.2175 3.10332C13.5668 3.17033 13.8179 3.26427 13.9319 3.37059"
            stroke="#f27373"
            strokeWidth="1.2"
            strokeLinecap="round"
        />
    </svg>
);

export const EditIcon = () => (
    <svg
        data-testid="edit-icon"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12.5 7.5L5.92819 14.0718C5.71566 14.2843 5.60939 14.3906 5.53953 14.5212C5.46966 14.6517 5.44019 14.7991 5.38124 15.0938L4.64709 18.7646C4.58057 19.0972 4.5473 19.2635 4.64191 19.3581C4.73652 19.4527 4.90283 19.4194 5.23544 19.3529L8.90621 18.6188C9.20093 18.5598 9.3483 18.5303 9.47885 18.4605C9.60939 18.3906 9.71566 18.2843 9.92819 18.0718L16.5 11.5L12.5 7.5Z"
            fill="#005b99"
            fillOpacity="0.25"
        />
        <path
            d="M5.95396 19.38L5.95397 19.38L5.9801 19.3734L5.98012 19.3734L8.60809 18.7164C8.62428 18.7124 8.64043 18.7084 8.65654 18.7044C8.87531 18.65 9.08562 18.5978 9.27707 18.4894C9.46852 18.381 9.62153 18.2275 9.7807 18.0679C9.79242 18.0561 9.80418 18.0444 9.81598 18.0325L17.0101 10.8385L17.0101 10.8385L17.0369 10.8117C17.3472 10.5014 17.6215 10.2272 17.8128 9.97638C18.0202 9.70457 18.1858 9.39104 18.1858 9C18.1858 8.60896 18.0202 8.29543 17.8128 8.02361C17.6215 7.77285 17.3472 7.49863 17.0369 7.18835L17.01 7.16152L16.8385 6.98995L16.8117 6.96314C16.5014 6.6528 16.2272 6.37853 15.9764 6.1872C15.7046 5.97981 15.391 5.81421 15 5.81421C14.609 5.81421 14.2954 5.97981 14.0236 6.1872C13.7729 6.37853 13.4986 6.65278 13.1884 6.96311L13.1615 6.98995L5.96745 14.184C5.95565 14.1958 5.94386 14.2076 5.93211 14.2193C5.77249 14.3785 5.61904 14.5315 5.51064 14.7229C5.40225 14.9144 5.34999 15.1247 5.29562 15.3435C5.29162 15.3596 5.28761 15.3757 5.28356 15.3919L4.62003 18.046C4.61762 18.0557 4.61518 18.0654 4.61272 18.0752C4.57411 18.2293 4.53044 18.4035 4.51593 18.5518C4.49978 18.7169 4.50127 19.0162 4.74255 19.2574C4.98383 19.4987 5.28307 19.5002 5.44819 19.4841C5.59646 19.4696 5.77072 19.4259 5.92479 19.3873C5.9346 19.3848 5.94433 19.3824 5.95396 19.38Z"
            stroke="#004473"
            strokeWidth="1.2"
        />
        <path d="M12.5 7.5L16.5 11.5" stroke="#004473" strokeWidth="1.2" />
    </svg>
);

export const DottedIcon = ({ size = 32 }) => (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16 10C17.1046 10 18 9.10457 18 8C18 6.89543 17.1046 6 16 6C14.8954 6 14 6.89543 14 8C14 9.10457 14.8954 10 16 10Z"
            fill="#4D4D4D"
        />
        <path
            d="M16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z"
            fill="#4D4D4D"
        />
        <path
            d="M16 25.3333C17.1046 25.3333 18 24.4379 18 23.3333C18 22.2288 17.1046 21.3333 16 21.3333C14.8954 21.3333 14 22.2288 14 23.3333C14 24.4379 14.8954 25.3333 16 25.3333Z"
            fill="#4D4D4D"
        />
    </svg>
);

export const UserIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.91667 8.33333C9.5275 8.33333 10.8333 7.0275 10.8333 5.41667C10.8333 3.80584 9.5275 2.5 7.91667 2.5C6.30583 2.5 5 3.80584 5 5.41667C5 7.0275 6.30583 8.33333 7.91667 8.33333Z"
            fill="white"
            stroke="white"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.66666 17V17.5H14.1667V17C14.1667 15.1332 14.1667 14.1997 13.8034 13.4867C13.4838 12.8595 12.9738 12.3495 12.3466 12.0299C11.6336 11.6667 10.7002 11.6667 8.83332 11.6667H6.99999C5.13316 11.6667 4.19974 11.6667 3.48669 12.0299C2.85948 12.3495 2.34954 12.8595 2.02997 13.4867C1.66666 14.1997 1.66666 15.1332 1.66666 17Z"
            fill="white"
            stroke="white"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.8333 5.41666V10.4167M13.3333 7.91666H18.3333"
            stroke="white"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const UploadIcon = ({ color }) => (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M25 20.8334V39.5834M25 20.8334L31.25 27.0834M25 20.8334L18.75 27.0834M36.4583 31.25C39.6229 31.25 41.6667 28.6854 41.6667 25.5209C41.6666 24.268 41.2558 23.0497 40.4972 22.0525C39.7386 21.0554 38.6741 20.3344 37.4667 20C37.2809 17.6635 36.3125 15.4579 34.7181 13.7398C33.1237 12.0217 30.9964 10.8916 28.6802 10.5322C26.364 10.1727 23.9943 10.6049 21.9542 11.759C19.914 12.913 18.3227 14.7214 17.4375 16.8917C15.5738 16.3751 13.5812 16.62 11.8981 17.5725C10.2149 18.525 8.97913 20.1072 8.46251 21.9709C7.94589 23.8346 8.19078 25.8272 9.14331 27.5103C10.0958 29.1934 11.678 30.4292 13.5417 30.9459"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const PeopleIcon = () => (
    <svg
        className="people-icon"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
            fill="#437499"
            fillOpacity="0.25"
        />
        <circle cx="12" cy="10" r="4" fill="white" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.221 18.2462C18.2791 18.3426 18.2614 18.466 18.1796 18.5432C16.5675 20.0662 14.3928 21 12.0001 21C9.60734 21 7.4327 20.0663 5.82063 18.5433C5.73883 18.466 5.72107 18.3427 5.77924 18.2463C6.94343 16.318 9.29221 15 12.0001 15C14.708 15 17.0568 16.3179 18.221 18.2462Z"
            fill="white"
        />
    </svg>
);

export const RemoveIcon = ({ size = 14, color = '#005B99' }) => {
    const ratio = 15 / 14;

    return (
        <svg width={size} height={size * ratio} viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.00008 13.3333C10.2217 13.3333 12.8334 10.7216 12.8334 7.49996C12.8334 4.2783 10.2217 1.66663 7.00008 1.66663C3.77842 1.66663 1.16675 4.2783 1.16675 7.49996C1.16675 10.7216 3.77842 13.3333 7.00008 13.3333Z"
                stroke={color}
                strokeLinejoin="round"
            />
            <path d="M8.64993 5.8501L5.3501 9.14993" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.3501 5.8501L8.64993 9.14993" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export const MoreIcon = ({ size = 24, color = '#2A3D4A' }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.9999 7.5C12.8283 7.5 13.4999 6.82843 13.4999 6C13.4999 5.17157 12.8283 4.5 11.9999 4.5C11.1715 4.5 10.4999 5.17157 10.4999 6C10.4999 6.82843 11.1715 7.5 11.9999 7.5Z"
                fill={color}
            />
            <path
                d="M11.9999 13.5C12.8283 13.5 13.4999 12.8284 13.4999 12C13.4999 11.1716 12.8283 10.5 11.9999 10.5C11.1715 10.5 10.4999 11.1716 10.4999 12C10.4999 12.8284 11.1715 13.5 11.9999 13.5Z"
                fill={color}
            />
            <path
                d="M11.9999 19C12.8283 19 13.4999 18.3284 13.4999 17.5C13.4999 16.6716 12.8283 16 11.9999 16C11.1715 16 10.4999 16.6716 10.4999 17.5C10.4999 18.3284 11.1715 19 11.9999 19Z"
                fill={color}
            />
        </svg>
    );
};

export const EyeIcon = ({ size = 24, color = '#215AA8' }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 18C17.5229 18 22 12 22 12C22 12 17.5229 6 12 6C6.47715 6 2 12 2 12C2 12 6.47715 18 12 18Z"
                stroke={color}
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5Z"
                stroke={color}
                strokeWidth="2"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const TrashcanIcon = ({ size = 24, color = '#E6001C' }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.375 3.75V16.5H14.625V3.75H3.375Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
            <path d="M7.5 7.5V12.375" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.5 7.5V12.375" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M1.5 3.75H16.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6 3.75L7.23337 1.5H10.7914L12 3.75H6Z" stroke={color} strokeLinejoin="round" />
        </svg>
    );
};

export const ArrowIcon = ({ size = 18, color = '#2A3D4A', isRight }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ transform: isRight ? 'rotate(180deg)' : 'rotate(0)' }}
        >
            <path
                d="M11.625 13.5L7.125 9L11.625 4.5"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const CalendarIcon2 = ({ size = 16, color = '#2A3D4A' }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.66699 6.33331H14.3337V13.3333C14.3337 13.7015 14.0352 14 13.667 14H2.33366C1.96547 14 1.66699 13.7015 1.66699 13.3333V6.33331Z"
                stroke={color}
                strokeWidth="1.33"
                strokeLinejoin="round"
            />
            <path
                d="M1.66699 2.99998C1.66699 2.63179 1.96547 2.33331 2.33366 2.33331H13.667C14.0352 2.33331 14.3337 2.63179 14.3337 2.99998V6.33331H1.66699V2.99998Z"
                stroke={color}
                strokeWidth="1.33"
                strokeLinejoin="round"
            />
            <path
                d="M5.33301 1.33331V3.99998"
                stroke={color}
                strokeWidth="1.33"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.667 1.33331V3.99998"
                stroke={color}
                strokeWidth="1.33"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.33301 11.3333H11.333"
                stroke={color}
                strokeWidth="1.33"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.66699 11.3333H6.66699"
                stroke={color}
                strokeWidth="1.33"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.33301 8.66669H11.333"
                stroke={color}
                strokeWidth="1.33"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.66699 8.66669H6.66699"
                stroke={color}
                strokeWidth="1.33"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const AddNewIcon = ({ size = 24, color = '#ffffff' }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 22C17.5229 22 22 17.5229 22 12C22 6.47715 17.5229 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path d="M12 8V16" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 12H16" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 8V16" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 12H16" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export const EditIcon2 = ({ size = 16, color = '#215AA8' }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.33301 14H14.333"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.66699 8.90663V11.3333H6.10606L13.0003 4.43603L10.5654 2L3.66699 8.90663Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const SaveIcon = ({ size = 16, color = '#215AA8', strokeWidth = '2' }) => {
    const ratio = 25 / 24;

    return (
        <svg width={size} height={size * ratio} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.15 3H4.85C4.10441 3 3.5 3.60441 3.5 4.35V19.65C3.5 20.3956 4.10441 21 4.85 21H20.15C20.8956 21 21.5 20.3956 21.5 19.65V4.35C21.5 3.60441 20.8956 3 20.15 3Z"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinejoin="round"
            />
            <path d="M16.5 3V12H8V3H16.5Z" stroke={color} strokeWidth={strokeWidth} strokeLinejoin="round" />
            <path d="M13.5 6.5V8.5" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
            <path d="M5.99854 3H18.4993" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
        </svg>
    );
};

export function UploadIcon2({ size = 24, color = '#215AA8' }) {
    return (
        <svg width={size} height={size} viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1 7.50277V13.5H13V7.5"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 4.5L7 1.5L4 4.5"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.99707 10.1667V1.5"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default function CheckIcon({ size = 16 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.00098 0.666992C10.0258 0.666992 11.8602 1.48812 13.1865 2.81445C14.5129 4.14081 15.334 5.97515 15.334 8C15.334 10.0248 14.5129 11.8592 13.1865 13.1855C11.8602 14.5119 10.0258 15.333 8.00098 15.333C5.97613 15.333 4.14178 14.5119 2.81543 13.1855C1.48909 11.8592 0.667969 10.0248 0.667969 8C0.667969 5.97515 1.4891 4.14081 2.81543 2.81445C4.14179 1.48812 5.97613 0.666992 8.00098 0.666992ZM8.00098 2C6.34396 2 4.84533 2.6713 3.75879 3.75781C2.67227 4.84435 2.00098 6.34298 2.00098 8C2.00098 9.65702 2.67227 11.1557 3.75879 12.2422C4.84532 13.3287 6.34396 14 8.00098 14C9.658 14 11.1566 13.3287 12.2432 12.2422C13.3297 11.1557 14.001 9.65702 14.001 8C14.001 6.34298 13.3297 4.84435 12.2432 3.75781C11.1566 2.6713 9.658 2 8.00098 2ZM10.8633 5.52832C11.1236 5.26835 11.5454 5.26824 11.8057 5.52832C12.066 5.78867 12.066 6.21133 11.8057 6.47168L7.80566 10.4717C7.54541 10.7318 7.1236 10.7316 6.86328 10.4717L4.86328 8.47168C4.60293 8.21133 4.60293 7.78867 4.86328 7.52832C5.1236 7.26835 5.54541 7.26824 5.80566 7.52832L7.33398 9.05762L10.8633 5.52832Z"
                fill="#40bf75"
            />
        </svg>
    );
}

export function DownloadIcon({ size = 24, color = '#215AA8', strokeWidth = 2 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.5 10.0035V17.5H17.5V10"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.75 9.5835L10 13.3335L6.25 9.5835"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.99658 2.5V13.3333"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export const ExcelIcon = ({ size = 24 }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4 7.5V3C4 2.44771 4.44771 2 5 2H19C19.5523 2 20 2.44771 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44771 22 4 21.5523 4 21V16.5"
                stroke="#33995E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M15.5 7.5H17" stroke="#33995E" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M14 11.5H17" stroke="#33995E" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M14 15.5H17" stroke="#33995E" strokeWidth="1.5" strokeLinecap="round" />
            <path
                d="M11 7.5H2V16.5H11V7.5Z"
                stroke="#33995E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M5 10.5L8 13.5" stroke="#33995E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 10.5L5 13.5" stroke="#33995E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
export const PDFIcon = ({ size = 24 }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 38V44H38V38" stroke="#E52424" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M38 20V14L30 4H10V20"
                stroke="#E52424"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M28 4V14H38" stroke="#E52424" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <rect x="4" y="20" width="40" height="18" rx="2" stroke="#E52424" strokeWidth="3" strokeLinejoin="round" />
            <path d="M21 25V33" stroke="#E52424" strokeWidth="3" strokeLinecap="round" />
            <path d="M10 25V33" stroke="#E52424" strokeWidth="3" strokeLinecap="round" />
            <path d="M32 33V25H37" stroke="#E52424" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M32 30H37" stroke="#E52424" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M10 25H13.5C14.8807 25 16 26.1193 16 27.5V27.5C16 28.8807 14.8807 30 13.5 30H10"
                stroke="#E52424"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21 25H23C25.2091 25 27 26.7909 27 29V29C27 31.2091 25.2091 33 23 33H21"
                stroke="#E52424"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M16 12H20" stroke="#E52424" strokeWidth="3" strokeLinecap="round" />
        </svg>
    );
};

export function FailedIcon({ size = 63, color = '#E6001C', withBotShadow = false }) {
    const ratio = 62 / 56;
    return (
        <svg
            width={size}
            height={withBotShadow ? size * Math.ceil(ratio) : size}
            viewBox={`0 0 56 ${withBotShadow ? '62' : '56'}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M28.0008 51.3332C40.8875 51.3332 51.3341 40.8865 51.3341 27.9999C51.3341 15.1132 40.8875 4.66656 28.0008 4.66656C15.1142 4.66656 4.66748 15.1132 4.66748 27.9999C4.66748 40.8865 15.1142 51.3332 28.0008 51.3332Z"
                fill={color}
                stroke={color}
                strokeWidth="4.66667"
                strokeLinejoin="round"
            />
            <path
                d="M34.5987 21.4004L21.3994 34.5997"
                stroke="white"
                strokeWidth="4.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.3994 21.4004L34.5987 34.5997"
                stroke="white"
                strokeWidth="4.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            {withBotShadow && <ellipse cx="28" cy="59" rx="28" ry="3" fill="#EBEBEB" />}
        </svg>
    );
}

export function SuccessIcon({ size = 64, color = '#33995E', withBotShadow = false }) {
    const ratio = 63 / 56;

    return (
        <svg
            width={size}
            height={withBotShadow ? size * Math.ceil(ratio) : size}
            viewBox={`0 0 56 ${withBotShadow ? '63' : '56'}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M28.0001 51.8333C34.4433 51.8333 40.2767 49.2216 44.4992 44.9991C48.7217 40.7766 51.3334 34.9432 51.3334 28.5C51.3334 22.0567 48.7217 16.2234 44.4992 12.0008C40.2767 7.7783 34.4433 5.16663 28.0001 5.16663C21.5568 5.16663 15.7235 7.7783 11.5009 12.0008C7.27842 16.2234 4.66675 22.0567 4.66675 28.5C4.66675 34.9432 7.27842 40.7766 11.5009 44.9991C15.7235 49.2216 21.5568 51.8333 28.0001 51.8333Z"
                fill={color}
                stroke={color}
                strokeWidth="3.5"
                strokeLinejoin="round"
            />
            <path
                d="M18.6667 28.5L25.6667 35.5L39.6667 21.5"
                stroke="white"
                strokeWidth="3.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {withBotShadow && <ellipse cx="28" cy="59.5" rx="28" ry="3" fill="#EBEBEB" />}
        </svg>
    );
}

export function DocsIcon({ size = 18, color = '#215AA8' }) {
    const ratio = 19 / 18;

    return (
        <svg width={size} height={size * ratio} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.875 14.75H15.375V6.5H11.25V2H4.875V14.75Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.25 2L15.375 6.5"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M2.625 8V17H10.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.125 8H8.625" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
            <path d="M7.125 11H11.625" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );
}

export function WarningIcon({ size = 16, color = '#D1A400' }) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_278_49379)">
                <path
                    d="M7.99992 14.6668C9.84085 14.6668 11.5075 13.9206 12.714 12.7142C13.9204 11.5078 14.6666 9.8411 14.6666 8.00016C14.6666 6.15923 13.9204 4.49256 12.714 3.28612C11.5075 2.07969 9.84085 1.3335 7.99992 1.3335C6.15899 1.3335 4.49232 2.07969 3.28587 3.28612C2.07945 4.49256 1.33325 6.15923 1.33325 8.00016C1.33325 9.8411 2.07945 11.5078 3.28587 12.7142C4.49232 13.9206 6.15899 14.6668 7.99992 14.6668Z"
                    stroke={color}
                    strokeWidth="1.2"
                    strokeLinejoin="round"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.00008 12.3332C8.46032 12.3332 8.83342 11.9601 8.83342 11.4998C8.83342 11.0396 8.46032 10.6665 8.00008 10.6665C7.53985 10.6665 7.16675 11.0396 7.16675 11.4998C7.16675 11.9601 7.53985 12.3332 8.00008 12.3332Z"
                    fill={color}
                />
                <path d="M8 4V9.33333" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </svg>
    );
}

export const SuccessIcon2 = ({ size = 160 }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g style={{ mixBlendMode: 'multiply' }} opacity="0.2">
                <path
                    d="M79.9992 134.286C95.7787 134.286 108.571 133.774 108.571 133.143C108.571 132.512 95.7787 132 79.9992 132C64.2196 132 51.4277 132.512 51.4277 133.143C51.4277 133.774 64.2196 134.286 79.9992 134.286Z"
                    fill="#1A4C2F"
                />
            </g>
            <path
                d="M80.0039 33.1426C83.2629 33.1426 86.4371 34.1828 89.0635 36.1123L89.0645 36.1133L94.5723 40.1445C95.5528 40.8623 96.6939 41.3374 97.8936 41.5234H97.8945L104.642 42.5605C107.86 43.0553 110.837 44.5638 113.14 46.8662C115.298 49.0246 116.759 51.7756 117.341 54.7627L117.445 55.3633L118.477 62.1162V62.1172C118.639 63.1669 119.023 64.1718 119.598 65.0635L119.855 65.4385L123.888 70.9404V70.9414C125.817 73.5676 126.858 76.7412 126.858 80C126.858 83.2588 125.817 86.4324 123.888 89.0586V89.0596L119.856 94.5605C119.135 95.5404 118.661 96.6802 118.477 97.8828L117.439 104.63V104.631C116.945 107.851 115.436 110.829 113.133 113.133C110.973 115.293 108.22 116.753 105.23 117.334L104.63 117.438L97.8828 118.477C96.6794 118.66 95.5383 119.133 94.5586 119.855L89.0576 123.887C86.4312 125.816 83.2571 126.857 79.998 126.857C76.739 126.857 73.5649 125.816 70.9385 123.887H70.9375L65.4355 119.854C64.5783 119.224 63.5985 118.783 62.5615 118.559L62.1133 118.477L55.3662 117.438C52.1478 116.944 49.1707 115.436 46.8682 113.134C44.5656 110.831 43.0573 107.854 42.5625 104.636L41.5244 97.8896H41.5254C41.3647 96.8366 40.9816 95.8316 40.4043 94.9404L40.1455 94.5654L36.1143 89.0654V89.0645L35.7627 88.5654C34.0585 86.0409 33.1436 83.0609 33.1436 80.0059C33.1436 76.747 34.1846 73.5735 36.1143 70.9473V70.9463L40.1465 65.4443C40.8643 64.4638 41.3384 63.3227 41.5244 62.123V62.1221L42.5625 55.3633C43.0573 52.1451 44.5657 49.1686 46.8682 46.8662C49.1707 44.5639 52.1478 43.0553 55.3662 42.5605L62.1191 41.5234H62.1201C63.1699 41.3606 64.1747 40.9766 65.0664 40.4023L65.4414 40.1445L70.9434 36.1133L70.9443 36.1123C73.5707 34.1829 76.7449 33.1426 80.0039 33.1426Z"
                fill="white"
                stroke="#267346"
                strokeWidth="1.14286"
            />
            <path
                d="M88.3819 40.4613L93.2929 44.0557C94.1017 44.6477 95.0426 45.0389 96.0312 45.1922L102.047 46.1172C105.024 46.5748 107.777 47.9696 109.906 50.099C112.036 52.2283 113.431 54.9813 113.888 57.9577L114.808 63.9784C114.961 64.9669 115.352 65.9078 115.945 66.7165L119.539 71.6219C121.324 74.0508 122.286 76.9861 122.286 80.0001C122.286 83.0141 121.324 85.9494 119.539 88.3783L115.945 93.2836C115.35 94.0911 114.96 95.0306 114.808 96.0218L113.883 102.037C113.426 105.015 112.031 107.77 109.9 109.9C107.77 112.031 105.015 113.426 102.036 113.883L96.0206 114.808C95.0292 114.959 94.0894 115.349 93.2823 115.944L88.3766 119.539C85.9476 121.323 83.0121 122.286 79.9979 122.286C76.9837 122.286 74.0483 121.323 71.6192 119.539L66.7135 115.944C65.906 115.35 64.9664 114.96 63.9752 114.808L57.9595 113.883C54.9829 113.425 52.2297 112.031 50.1002 109.901C47.9707 107.772 46.5758 105.019 46.1182 102.042L45.1931 96.027C45.0419 95.0357 44.6518 94.096 44.0566 93.2889L40.4619 88.3836C38.6773 85.9546 37.7148 83.0194 37.7148 80.0054C37.7148 76.9914 38.6773 74.0561 40.4619 71.6272L44.0566 66.7218C44.6486 65.9131 45.0398 64.9722 45.1931 63.9837L46.1182 57.9577C46.5758 54.9813 47.9707 52.2283 50.1002 50.099C52.2297 47.9696 54.9829 46.5748 57.9595 46.1172L63.9805 45.1922C64.9691 45.0389 65.91 44.6477 66.7188 44.0557L71.6245 40.4613C74.0535 38.6767 76.989 37.7144 80.0032 37.7144C83.0174 37.7144 85.9529 38.6767 88.3819 40.4613Z"
                fill="#33995E"
            />
            <g style={{ mixBlendMode: 'multiply' }} opacity="0.2">
                <path
                    d="M74.0364 99.9946H73.9944C73.3534 100.005 72.7229 99.8899 72.1292 99.6544C71.5303 99.4136 70.9996 99.0629 70.5425 98.618L60.3077 88.5834C59.8559 88.1437 59.4933 87.6203 59.2464 87.034C58.9942 86.453 58.8628 85.8353 58.8576 85.2019C58.8523 84.5686 58.9679 83.9457 59.2096 83.3594C59.4513 82.7679 59.7981 82.2392 60.2447 81.789C60.6965 81.3336 61.2219 80.9777 61.8051 80.7369C62.3883 80.4909 63.0188 80.3862 63.6493 80.36C64.2902 80.36 64.9102 80.4752 65.5039 80.716C66.0924 80.9567 66.623 81.3075 67.0749 81.7576L73.8105 88.3636L95.1313 66.0594C96.0192 65.1329 97.2171 64.6042 98.4991 64.5728C99.7811 64.5414 101.005 65.0125 101.935 65.8919C102.865 66.7765 103.396 67.97 103.427 69.2472C103.459 70.5296 102.986 71.744 102.098 72.6705L77.399 98.5133C76.9577 98.9739 76.4375 99.3403 75.8491 99.5968C75.2711 99.8481 74.6617 99.9842 74.0312 99.9999L74.0364 99.9946Z"
                    fill="#1A4C2F"
                />
            </g>
            <path
                d="M73.4642 97.709H73.4221C72.7811 97.7195 72.1507 97.6043 71.557 97.3687C70.958 97.128 70.4273 96.7772 69.9702 96.3323L59.7354 86.2978C59.2836 85.8581 58.9211 85.3346 58.6741 84.7484C58.4219 84.1673 58.2906 83.5497 58.2853 82.9163C58.2801 82.2829 58.3957 81.66 58.6373 81.0737C58.879 80.4822 59.2258 79.9536 59.6724 79.5034C60.1242 79.048 60.6496 78.692 61.2328 78.4513C61.816 78.2052 62.4465 78.1005 63.077 78.0744C63.718 78.0744 64.3379 78.1895 64.9317 78.4303C65.5201 78.6711 66.0508 79.0218 66.5026 79.472L73.2382 86.0779L94.559 63.7737C95.4469 62.8472 96.6449 62.3185 97.9268 62.2871C99.2088 62.2557 100.433 62.7268 101.363 63.6062C102.293 64.4908 102.824 65.6843 102.855 66.9615C102.887 68.244 102.414 69.4584 101.526 70.3849L76.8267 96.2276C76.3854 96.6883 75.8652 97.0547 75.2768 97.3112C74.6989 97.5624 74.0894 97.6985 73.4589 97.7142L73.4642 97.709Z"
                fill="white"
            />
        </svg>
    );
};

export const FailedIcon2 = ({ size = 160 }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g style={{ mixBlendMode: 'multiply' }} opacity="0.2">
                <path
                    d="M79.9992 134.286C95.7787 134.286 108.571 133.774 108.571 133.143C108.571 132.512 95.7787 132 79.9992 132C64.2196 132 51.4277 132.512 51.4277 133.143C51.4277 133.774 64.2196 134.286 79.9992 134.286Z"
                    fill="#5C000B"
                />
            </g>
            <path
                d="M80.001 33.1431C105.837 33.1431 126.858 54.1643 126.858 80.0005C126.858 105.837 105.837 126.858 80.001 126.858C54.1648 126.858 33.1436 105.837 33.1436 80.0005C33.1436 54.1643 54.1647 33.1431 80.001 33.1431Z"
                fill="white"
                stroke="#8A0011"
                strokeWidth="1.14286"
            />
            <path
                d="M80.0006 122.286C103.354 122.286 122.286 103.354 122.286 80.0003C122.286 56.6466 103.354 37.7146 80.0006 37.7146C56.6468 37.7146 37.7148 56.6466 37.7148 80.0003C37.7148 103.354 56.6468 122.286 80.0006 122.286Z"
                fill="#E6001C"
            />
            <g style={{ mixBlendMode: 'multiply' }} opacity="0.2">
                <path
                    d="M98.5416 63.9946C96.4901 61.9546 93.153 61.9546 91.1016 63.9946L80.793 74.246L70.4844 63.9946C68.433 61.9546 65.0959 61.9546 63.0444 63.9946C60.993 66.0346 60.993 69.3546 63.0444 71.3946L73.353 81.646L63.0444 91.8975C60.993 93.9375 60.993 97.2575 63.0444 99.2975C65.0901 101.337 68.433 101.337 70.4844 99.2975L80.793 89.046L91.1016 99.2975C93.1473 101.337 96.4901 101.337 98.5416 99.2975C100.593 97.2575 100.593 93.9375 98.5416 91.8975L88.233 81.646L98.5416 71.3946C100.593 69.3546 100.593 66.0346 98.5416 63.9946Z"
                    fill="#5C000B"
                />
            </g>
            <path
                d="M97.9713 61.7087C95.9198 59.6687 92.5827 59.6687 90.5313 61.7087L80.2227 71.9601L69.9141 61.7087C67.8627 59.6687 64.5255 59.6687 62.4741 61.7087C60.4227 63.7487 60.4227 67.0687 62.4741 69.1087L72.7827 79.3601L62.4741 89.6116C60.4227 91.6516 60.4227 94.9716 62.4741 97.0116C64.5198 99.0516 67.8627 99.0516 69.9141 97.0116L80.2227 86.7601L90.5313 97.0116C92.577 99.0516 95.9198 99.0516 97.9713 97.0116C100.023 94.9716 100.023 91.6516 97.9713 89.6116L87.6627 79.3601L97.9713 69.1087C100.023 67.0687 100.023 63.7487 97.9713 61.7087Z"
                fill="white"
            />
            <g style={{ mixBlendMode: 'multiply' }} opacity="0.2">
                <path
                    d="M81.6509 73.3889L74.2109 80.7889L81.6509 88.1889L89.0909 80.7889L81.6509 73.3889Z"
                    fill="#5C000B"
                />
            </g>
            <g style={{ mixBlendMode: 'multiply' }} opacity="0.2">
                <path
                    d="M79.9361 71.6743L72.4961 79.0743L79.9361 86.4743L87.3761 79.0743L79.9361 71.6743Z"
                    fill="#5C000B"
                />
            </g>
            <path
                d="M97.9713 61.7087C95.9198 59.6687 92.5827 59.6687 90.5313 61.7087C74.9732 77.1805 80.1725 72.0112 62.4741 89.6116C60.4227 91.6516 60.4227 94.9716 62.4741 97.0116C64.5198 99.0516 67.8627 99.0516 69.9141 97.0116C87.7274 79.297 82.4066 84.5871 97.9713 69.1087C100.023 67.0687 100.023 63.7487 97.9713 61.7087Z"
                fill="white"
            />
        </svg>
    );
};

export function CheckMarkIcon({ size = 12, color = '#1A4C2F' }) {
    return (
        <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.5 6L5 8.5L10 3.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export function DoubleCheckMarkIcon({ size = 12, color = '#1A4C2F' }) {
    return (
        <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.5 6L6 8.5L11 3.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M1 6L3.5 8.5L4.75 7.25M8.5 3.5L6 6" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export function SellOutIcon({ size = 16, color = '#005B99' }) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.666 4.66663H3.33268C2.96449 4.66663 2.66602 4.96509 2.66602 5.33329V14C2.66602 14.3682 2.96449 14.6666 3.33268 14.6666H12.666C13.0342 14.6666 13.3327 14.3682 13.3327 14V5.33329C13.3327 4.96509 13.0342 4.66663 12.666 4.66663Z"
                stroke={color}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.66602 6.00004V3.66671C5.66602 2.37804 6.71068 1.33337 7.99935 1.33337C9.28802 1.33337 10.3327 2.37804 10.3327 3.66671V6.00004"
                stroke={color}
                strokeWidth="1.064"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.6673 10L5.33398 10"
                stroke={color}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.33398 12L5.33398 10L7.33398 8"
                stroke={color}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function ProductIcon({ size = 16, color = '#005b99' }) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.6673 4.66671L8.00065 1.33337L1.33398 4.66671V11.3334L8.00065 14.6667L14.6673 11.3334V4.66671Z"
                stroke={color}
                strokeWidth="1.2"
                strokeLinejoin="round"
            />
            <path
                d="M1.33398 4.66663L8.00065 7.99996"
                stroke={color}
                strokeWidth="0.96"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M8 14.6667V8" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M14.6667 4.66663L8 7.99996"
                stroke={color}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.3327 3L4.66602 6.33333"
                stroke={color}
                strokeWidth="0.96"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function StarIcon({ size = 16, color = '#005B99' }) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.00019 1.66663L5.96252 5.82583L1.33398 6.49699L4.68695 9.77499L3.88545 14.3333L8.00019 12.1397L12.1158 14.3333L11.3202 9.77499L14.6673 6.49699L10.0644 5.82583L8.00019 1.66663Z"
                stroke={color}
                strokeWidth="1.2"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function ProcessingStateImage() {
    return (
        <svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19.2405 43.4285C10.6795 43.4285 3.93958 50.2242 4.61843 58.1717L8.55679 104.006C9.16559 111.102 15.5284 116.571 23.1788 116.571H136.82C144.465 116.571 150.828 111.102 151.442 104.006L155.381 58.1717C156.065 50.2297 149.319 43.4285 140.759 43.4285H19.2405Z"
                fill="#CCE2FF"
            />
            <path
                d="M48.0618 124.572L25.3818 61.5368C24.9418 60.3141 25.119 58.9199 25.839 57.8857C26.4275 57.0515 27.2961 56.5715 28.2275 56.5715H54.0047C55.2161 56.5715 56.3704 57.0972 57.2618 58.0571L61.6218 62.771H93.1818C95.1304 62.771 96.8675 64.1252 97.599 66.2164L117.702 123.509C117.788 123.754 117.753 124.017 117.599 124.234C117.45 124.446 117.21 124.572 116.953 124.572H48.0618Z"
                fill="#7A9CCB"
                stroke="#215AA8"
                strokewidth="1.14286"
            />
            <path
                d="M48.1017 124.571L36.9189 66.0049C36.8675 65.7649 36.9189 65.525 37.0617 65.3535C37.1646 65.2221 37.3075 65.1536 37.456 65.1536H106.77L117.953 123.623C117.999 123.857 117.936 124.097 117.787 124.28C117.639 124.463 117.41 124.566 117.176 124.566L48.1075 123.994L48.1017 124.571Z"
                fill="white"
                stroke="#215AA8"
                strokewidth="1.14286"
            />
            <path
                d="M46.8216 61.0339C46.8102 60.811 46.8845 60.611 47.0159 60.4682C47.1188 60.3596 47.2445 60.3025 47.3759 60.3025H116.302C116.599 60.3025 116.839 60.5825 116.856 60.9424L118.182 119.566L48.1359 123.971L46.8159 61.0224L46.8216 61.0339Z"
                fill="white"
                stroke="#215AA8"
                strokewidth="1.14286"
            />
            <path
                d="M58.0387 64.3821C58.1473 63.5707 58.7302 62.9822 59.4216 62.9822L130.113 62.668C130.25 62.668 130.387 62.7308 130.49 62.8508C130.627 63.0051 130.69 63.2336 130.662 63.4565L119.142 119.526L48.1987 123.977L58.033 64.3821H58.0387Z"
                fill="white"
                stroke="#215AA8"
                strokewidth="1.14286"
            />
            <path
                d="M48.5703 124.571L64.3589 71.7586C65.0046 69.4788 66.8275 67.9475 68.896 67.9475H131.199C132.096 67.9475 132.919 68.376 133.513 69.1645C134.245 70.1302 134.473 71.4272 134.13 72.6443L118.673 123.24C118.433 124.034 117.707 124.571 116.879 124.571H48.5703Z"
                fill="#D3DEEE"
                stroke="#215AA8"
                strokewidth="1.14286"
            />
            <path
                d="M114.501 116.492H92.1643C91.5129 116.492 91.1643 115.967 91.3872 115.315L95.81 102.299C96.0329 101.648 96.7357 101.122 97.3872 101.122H119.724C120.376 101.122 120.724 101.648 120.501 102.299L116.079 115.315C115.856 115.967 115.153 116.492 114.501 116.492Z"
                fill="#7A9CCB"
            />
            <g style={{ mixBlendMode: 'multiply' }} opacity="0.2">
                <path
                    d="M110.691 76.5714C121.513 76.5714 130.286 67.7987 130.286 56.9771C130.286 46.1555 121.513 37.3828 110.691 37.3828C99.8698 37.3828 91.0972 46.1555 91.0972 56.9771C91.0972 67.7987 99.8698 76.5714 110.691 76.5714Z"
                    fill="#0045A3"
                />
            </g>
            <path
                d="M108.737 74.617C119.559 74.617 128.332 65.8444 128.332 55.0228C128.332 44.2011 119.559 35.4285 108.737 35.4285C97.9157 35.4285 89.1431 44.2011 89.1431 55.0228C89.1431 65.8444 97.9157 74.617 108.737 74.617Z"
                fill="#3378D6"
            />
            <path
                d="M111.097 61.418L115.267 57.2484C116.119 56.3968 117.499 56.3967 118.351 57.2484C119.203 58.1001 119.203 59.481 118.351 60.3327L110.466 68.2183C110.147 68.5365 109.727 68.7501 109.285 68.8243L109.286 68.8248C108.586 68.9447 107.804 68.6943 107.3 68.1373L99.4957 60.3327C98.644 59.481 98.6441 58.1001 99.4957 57.2484C100.347 56.3968 101.728 56.3967 102.58 57.2484L106.735 61.403V43.8952C106.735 42.6905 107.712 41.7144 108.916 41.7144C110.103 41.7439 111.097 42.6844 111.097 43.8952V61.418Z"
                fill="white"
            />
        </svg>
    );
}

export function EmptyStateImage() {
    return (
        <svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19.2405 43.4285C10.6795 43.4285 3.93958 50.2242 4.61843 58.1717L8.55679 104.006C9.16559 111.102 15.5284 116.571 23.1788 116.571H136.82C144.465 116.571 150.828 111.102 151.442 104.006L155.381 58.1717C156.065 50.2297 149.319 43.4285 140.759 43.4285H19.2405Z"
                fill="#EBEBEB"
            />
            <path
                d="M32.2856 108.251V59.6229L80.9028 46.0115L126.571 60.6343V109.269L79.4342 125.411L32.2856 108.251Z"
                fill="white"
            />
            <path d="M126.857 109.023L79.4287 125.709V76.663L126.857 59.9773V109.023Z" fill="#C2C2C2" />
            <path d="M32 59.4058L79.4286 76.6686L126.857 60.4229L80.9086 45.7144L32 59.4058Z" fill="white" />
            <path d="M60.8227 69.8973L110.611 55.223L94.4856 50.063L46.457 64.6687L60.8227 69.8973Z" fill="#D6D6D6" />
            <path d="M60.8227 87.503V69.8973L46.457 64.6687V81.6458L52.7713 79.5487L60.8227 87.503Z" fill="#C2C2C2" />
            <path
                d="M79.4287 125.44V76.6629L32.4287 59.5601"
                stroke="#999999"
                strokeWidth="1.14286"
                strokeMiterlimit="10"
            />
            <path d="M126.423 60.5715L79.4287 76.663" stroke="#999999" strokeWidth="1.14286" strokeMiterlimit="10" />
            <path
                d="M32.2856 108.251V59.6229L80.9028 46.0115L126.571 60.6343V109.269L79.4342 125.411L32.2856 108.251Z"
                stroke="#999999"
                strokeWidth="1.14286"
            />
            <g style={{ mixBlendMode: 'multiply' }} opacity="0.2">
                <path
                    d="M119.834 76.0001C130.656 76.0001 139.428 67.2274 139.428 56.4058C139.428 45.5842 130.656 36.8115 119.834 36.8115C109.012 36.8115 100.24 45.5842 100.24 56.4058C100.24 67.2274 109.012 76.0001 119.834 76.0001Z"
                    fill="#7A7A7A"
                />
            </g>
            <path
                d="M117.88 74.0457C128.702 74.0457 137.474 65.2731 137.474 54.4515C137.474 43.6298 128.702 34.8572 117.88 34.8572C107.058 34.8572 98.2856 43.6298 98.2856 54.4515C98.2856 65.2731 107.058 74.0457 117.88 74.0457Z"
                fill="#7A7A7A"
            />
            <path
                d="M117.88 60.24C116.789 60.24 115.903 59.3543 115.903 58.2629V55C115.903 53.9086 116.789 53.0229 117.88 53.0229C119.491 53.0229 120.806 51.7143 120.806 50.0972C120.806 48.48 119.497 47.1715 117.88 47.1715C116.263 47.1715 114.954 48.48 114.954 50.0972C114.954 51.1886 114.069 52.0743 112.977 52.0743C111.886 52.0743 111 51.1886 111 50.0972C111 46.3086 114.086 43.2229 117.874 43.2229C121.663 43.2229 124.749 46.3086 124.749 50.0972C124.749 53.1429 122.749 55.8115 119.851 56.68V58.2572C119.851 59.3486 118.966 60.2343 117.874 60.2343L117.88 60.24Z"
                fill="white"
            />
            <path
                d="M117.88 65.5429C116.789 65.5429 115.903 64.6572 115.903 63.5658C115.903 62.4743 116.789 61.5886 117.88 61.5886C118.971 61.5886 119.857 62.4743 119.857 63.5658C119.857 64.6572 118.971 65.5429 117.88 65.5429Z"
                fill="white"
            />
        </svg>
    );
}

export function QuestionOutlineIcon({ size = 16, color = '#215AA8' }) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.99992 14.6666C9.84085 14.6666 11.5075 13.9204 12.714 12.714C13.9204 11.5075 14.6666 9.84085 14.6666 7.99992C14.6666 6.15899 13.9204 4.49232 12.714 3.28587C11.5075 2.07945 9.84085 1.33325 7.99992 1.33325C6.15899 1.33325 4.49232 2.07945 3.28587 3.28587C2.07945 4.49232 1.33325 6.15899 1.33325 7.99992C1.33325 9.84085 2.07945 11.5075 3.28587 12.714C4.49232 13.9204 6.15899 14.6666 7.99992 14.6666Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M8 9.54159V8.20825C9.10457 8.20825 10 7.31282 10 6.20825C10 5.10369 9.10457 4.20825 8 4.20825C6.89543 4.20825 6 5.10369 6 6.20825"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.99976 11.625C8.04567 11.625 8.08357 11.6621 8.08374 11.708C8.08374 11.754 8.04578 11.792 7.99976 11.792C7.95389 11.7918 7.91675 11.7539 7.91675 11.708C7.91692 11.6622 7.95399 11.6252 7.99976 11.625Z"
                fill="#2A3D4A"
                stroke={color}
                strokeWidth="1.5"
            />
        </svg>
    );
}

export function ParagonIcon({ size = 14, color = '#0056CC' }) {
    return (
        <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.37207 3.69678C2.59015 3.84505 2.96989 4.1033 3.21582 4.271C3.462 4.43888 3.96006 4.77933 4.32324 5.02686C4.68641 5.27438 5.26548 5.66838 5.60938 5.90283C5.83098 6.05392 6.03653 6.19363 6.15918 6.27686C6.16054 6.29785 6.16352 6.32231 6.16504 6.35107C6.17735 6.5851 6.1925 7.05235 6.22461 7.99854C6.24194 8.50823 6.26529 9.18869 6.27637 9.51123C6.28748 9.8335 6.31058 10.4955 6.32715 10.9819C6.33041 11.0778 6.33355 11.1764 6.33691 11.2739C6.0714 10.82 5.73451 10.2423 5.35254 9.59033C5.11565 9.18599 4.71053 8.49576 4.45312 8.05615C4.19574 7.61654 3.73778 6.83469 3.43555 6.31885C3.13338 5.80315 2.46228 4.65702 1.94434 3.77197C1.8199 3.55934 1.69844 3.35268 1.58594 3.16064C1.89194 3.36927 2.20764 3.58499 2.37207 3.69678ZM11.334 5.02295C10.3407 6.71972 9.33464 8.43893 9.09766 8.84424C8.52379 9.82569 8.02158 10.681 7.67773 11.2681C7.68906 10.9147 7.70456 10.469 7.71582 10.0962C7.7507 8.94359 7.77619 8.0942 7.80762 7.08057C7.81832 6.7363 7.82845 6.39826 7.83203 6.28076L8.24414 6.00049C8.54665 5.79443 9.13262 5.3965 9.5459 5.11572L10.7559 4.29346C11.0077 4.12221 11.6569 3.68047 12.1992 3.31201C12.2738 3.26134 12.3476 3.20951 12.4209 3.15967C12.1185 3.67868 11.7424 4.32537 11.334 5.02295ZM7.0127 1.79346C8.75707 1.79364 10.3068 1.79589 11.418 1.79932C11.6302 1.79997 11.8264 1.80053 12.0049 1.80127C11.5882 2.04545 11.0597 2.35618 10.4463 2.71533C9.59036 3.21653 8.4296 3.89722 7.86719 4.22705L7.01074 4.72803L5.78809 4.01318C5.02454 3.56595 3.63116 2.74989 2.69141 2.19971C2.4474 2.05684 2.21483 1.92008 2.00391 1.79639C2.19313 1.79604 2.40187 1.7957 2.62793 1.79541C3.75225 1.79395 5.30431 1.79329 7.0127 1.79346Z"
                fill={color}
                stroke={color}
                strokeWidth="0.65625"
            />
        </svg>
    );
}

export function CheckMarkBgIcon({ size = 24, bgColor = '#FFCD00', color = '#fff' }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 22C14.7614 22 17.2614 20.8807 19.0711 19.0711C20.8807 17.2614 22 14.7614 22 12C22 9.2386 20.8807 6.7386 19.0711 4.92893C17.2614 3.11929 14.7614 2 12 2C9.2386 2 6.7386 3.11929 4.92893 4.92893C3.11929 6.7386 2 9.2386 2 12C2 14.7614 3.11929 17.2614 4.92893 19.0711C6.7386 20.8807 9.2386 22 12 22Z"
                fill={bgColor}
                stroke={bgColor}
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path d="M8 12L11 15L17 9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export function ArrowMappingIcon({ size = 16 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.33301 2.66675L1.33301 4.66675L3.33301 6.66675"
                stroke="#2A3D4A"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.667 9.33325L14.667 11.3333L12.667 13.3333"
                stroke="#333333"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M1.33301 4.66675H14.6663" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M1.33301 11.3333H14.6663" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export function EmptyStateInfinite({ size = 60 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g style={{ mixBlendMode: 'multiply' }} opacity="0.2">
                <path
                    d="M28.9286 48.8569C38.278 48.8569 45.8571 48.4731 45.8571 47.9997C45.8571 47.5263 38.278 47.1426 28.9286 47.1426C19.5792 47.1426 12 47.5263 12 47.9997C12 48.4731 19.5792 48.8569 28.9286 48.8569Z"
                    fill="#7A7A7A"
                />
            </g>
            <path
                opacity="0.5"
                d="M23.4429 42.6539C22.7401 42.6539 22.1401 42.1503 22.0179 41.456L18.8358 23.411C18.6965 22.6246 19.2237 21.8703 20.0122 21.7332L28.1937 20.291L35.6187 25.6589L37.9115 38.6574C38.0508 39.4439 37.5237 40.1982 36.7351 40.3353L23.6979 42.6324C23.6144 42.6474 23.5287 42.6539 23.4451 42.6539H23.4429Z"
                fill="#D6D6D6"
            />
            <path
                d="M23.4429 42.6539C22.7401 42.6539 22.1401 42.1503 22.0179 41.456L18.8358 23.411C18.6965 22.6246 19.2237 21.8703 20.0122 21.7332L28.1937 20.291L35.6187 25.6589L37.9115 38.6574C38.0508 39.4439 37.5237 40.1982 36.7351 40.3353L23.6979 42.6324C23.6144 42.6474 23.5287 42.6539 23.4451 42.6539H23.4429Z"
                stroke="#999999"
                strokeWidth="0.214286"
            />
            <path
                d="M30.6582 26.2116C30.011 26.2116 29.4603 25.7487 29.3467 25.1102L28.541 20.5352L35.291 25.4144L30.8917 26.1902C30.8146 26.203 30.7374 26.2094 30.6582 26.2094V26.2116Z"
                fill="#EBEBEB"
                stroke="#999999"
                strokeWidth="0.214286"
            />
            <path
                d="M34.6016 36.7422L24.4717 38.5283L24.3232 37.6846L34.4521 35.8984L34.6016 36.7422ZM34.2266 34.6094L24.0967 36.3955L23.9482 35.5508L34.0771 33.7656L34.2266 34.6094ZM33.8516 32.4805L23.7217 34.2666L23.5732 33.4219L33.7021 31.6357L33.8516 32.4805ZM33.4736 30.3477L23.3447 32.1338L23.1953 31.2891L33.3252 29.5029L33.4736 30.3477ZM33.0986 28.2188L22.9697 30.0049L22.8203 29.1602L32.9502 27.374L33.0986 28.2188ZM27.5967 26.625L22.5312 27.5186L22.3828 26.6738L27.4473 25.7812L27.5967 26.625Z"
                fill="#C2C2C2"
            />
            <path
                d="M33.7046 37.1656L35.9203 35.2734L38.2774 38.0656L36.0596 39.9577L33.7046 37.1656Z"
                fill="#C2C2C2"
                stroke="#999999"
                strokeWidth="0.428571"
            />
            <path
                d="M42.8656 47.8919C42.2078 47.8919 41.5885 47.6047 41.1621 47.1054L35.5799 40.5633C35.4621 40.4262 35.4063 40.2526 35.4213 40.0726C35.4363 39.8926 35.5199 39.7297 35.6549 39.6119L38.0335 37.5826C38.1556 37.4776 38.3099 37.4219 38.4706 37.4219C38.6678 37.4219 38.8563 37.5076 38.9849 37.6597L44.5671 44.2019C44.9549 44.6562 45.1435 45.2347 45.0963 45.8304C45.0492 46.4262 44.7728 46.9683 44.3185 47.3562C43.9135 47.7012 43.3971 47.8919 42.8656 47.8919Z"
                fill="#EBEBEB"
                stroke="#999999"
                strokeWidth="0.428571"
            />
            <path
                d="M26.1168 40.0732C25.7504 40.0732 25.3776 40.0582 25.0068 40.0282C21.3404 39.7389 18.0061 38.0375 15.6168 35.2389C13.2297 32.4403 12.0747 28.8811 12.364 25.2125C12.6533 21.5439 14.3547 18.2118 17.1533 15.8225C19.639 13.7011 22.8104 12.5332 26.0826 12.5332C30.1304 12.5332 33.9511 14.2925 36.5676 17.3589C38.9504 20.1532 40.1033 23.7125 39.814 27.3853C39.5226 31.0561 37.8254 34.3903 35.0311 36.7753C32.5411 38.9011 29.374 40.0711 26.1147 40.0711L26.1168 40.0732ZM26.0847 14.8518C23.3633 14.8518 20.7254 15.8225 18.6576 17.5882C16.3304 19.5746 14.9161 22.3475 14.674 25.3968C14.4318 28.4461 15.394 31.4075 17.3783 33.7368C19.3647 36.0639 22.1376 37.4782 25.1868 37.7203C25.4933 37.7439 25.804 37.7568 26.1104 37.7568C28.8211 37.7568 31.4547 36.7839 33.5268 35.0139C38.3311 30.9146 38.9054 23.6696 34.8061 18.8653C32.629 16.3153 29.4511 14.8518 26.0847 14.8518Z"
                fill="white"
                stroke="#999999"
                strokeWidth="0.428571"
            />
            <g style={{ mixBlendMode: 'multiply' }} opacity="0.2">
                <path
                    d="M41.0808 27.643C45.1389 27.643 48.4286 24.3532 48.4286 20.2951C48.4286 16.237 45.1389 12.9473 41.0808 12.9473C37.0227 12.9473 33.7329 16.237 33.7329 20.2951C33.7329 24.3532 37.0227 27.643 41.0808 27.643Z"
                    fill="#7A7A7A"
                />
            </g>
            <path
                d="M40.3479 26.9106C44.406 26.9106 47.6957 23.6208 47.6957 19.5627C47.6957 15.5046 44.406 12.2148 40.3479 12.2148C36.2897 12.2148 33 15.5046 33 19.5627C33 23.6208 36.2897 26.9106 40.3479 26.9106Z"
                fill="#7A7A7A"
            />
            <path
                d="M40.3477 22.75C40.8555 22.75 41.2676 23.1611 41.2676 23.6689V23.6797C41.2675 24.1875 40.8555 24.5986 40.3477 24.5986C39.84 24.5984 39.4288 24.1874 39.4287 23.6797V23.6689C39.4287 23.1612 39.84 22.7502 40.3477 22.75ZM40.3477 14.5254C40.8554 14.5254 41.2674 14.9366 41.2676 15.4443V20.8252C41.2676 21.3331 40.8555 21.7441 40.3477 21.7441C39.84 21.744 39.4287 21.3329 39.4287 20.8252V15.4443C39.4289 14.9367 39.8401 14.5256 40.3477 14.5254Z"
                fill="white"
            />
        </svg>
    );
}

export const FilterIcon2 = ({ size = 16, color = '#005B99' }) => {
    const ratio = 20 / 21;
    return (
        <svg width={size} height={size * ratio} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.58325 7.16663V18"
                stroke={color}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M10 12.5834V18" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 8.41667V3" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M15.4167 3V13.8333"
                stroke={color}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.58333 7.16667C5.73392 7.16667 6.66667 6.23392 6.66667 5.08333C6.66667 3.93274 5.73392 3 4.58333 3C3.43274 3 2.5 3.93274 2.5 5.08333C2.5 6.23392 3.43274 7.16667 4.58333 7.16667Z"
                stroke={color}
                strokeWidth="1.6"
                strokeLinejoin="round"
            />
            <path
                d="M10.0001 12.5833C11.1507 12.5833 12.0834 11.6505 12.0834 10.5C12.0834 9.34938 11.1507 8.41663 10.0001 8.41663C8.8495 8.41663 7.91675 9.34938 7.91675 10.5C7.91675 11.6505 8.8495 12.5833 10.0001 12.5833Z"
                stroke={color}
                strokeWidth="1.6"
                strokeLinejoin="round"
            />
            <path
                d="M15.4166 18C16.5672 18 17.4999 17.0673 17.4999 15.9167C17.4999 14.7661 16.5672 13.8334 15.4166 13.8334C14.266 13.8334 13.3333 14.7661 13.3333 15.9167C13.3333 17.0673 14.266 18 15.4166 18Z"
                stroke={color}
                strokeWidth="1.6"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const InfoOutlineIcon = ({ size = 16, color = '#2A3D4A' }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_50_87257" fill="white">
                <path d="M7.99969 0.666626C10.0244 0.666626 11.8589 1.48794 13.1852 2.81409C14.5115 4.14037 15.3336 5.97492 15.3337 7.99963C15.3337 10.0245 14.5116 11.8588 13.1852 13.1852C11.8589 14.5115 10.0245 15.3336 7.99969 15.3336C5.97498 15.3335 4.14043 14.5115 2.81415 13.1852C1.488 11.8589 0.666687 10.0243 0.666687 7.99963C0.666775 5.97492 1.48788 4.14037 2.81415 2.81409C4.14043 1.48782 5.97498 0.666714 7.99969 0.666626ZM7.99969 1.99963C6.34281 1.99972 4.84397 2.671 3.75751 3.75745C2.67106 4.84391 1.99978 6.34274 1.99969 7.99963C1.99969 9.65666 2.67099 11.1563 3.75751 12.2428C4.84396 13.3292 6.34289 13.9995 7.99969 13.9996C9.65671 13.9996 11.1563 13.3293 12.2429 12.2428C13.3294 11.1563 13.9997 9.65665 13.9997 7.99963C13.9996 6.34283 13.3292 4.8439 12.2429 3.75745C11.1563 2.67093 9.65672 1.99963 7.99969 1.99963ZM8.16669 5.99963C8.53488 5.99963 8.83368 6.29844 8.83368 6.66663V10.6666H9.33368C9.70172 10.6668 9.99969 10.9655 9.99969 11.3336C9.99952 11.7015 9.70161 11.9995 9.33368 11.9996H6.99969C6.63176 11.9995 6.33386 11.7015 6.33368 11.3336C6.33368 10.9655 6.63165 10.6668 6.99969 10.6666H7.49969V7.33362C7.13165 7.33344 6.83368 7.03471 6.83368 6.66663C6.83368 6.29854 7.13165 5.99981 7.49969 5.99963H8.16669ZM7.99969 3.66663C8.45982 3.66663 8.8335 4.03955 8.83368 4.49963C8.83368 4.95987 8.45993 5.33362 7.99969 5.33362C7.53961 5.33344 7.16669 4.95976 7.16669 4.49963C7.16686 4.03966 7.53972 3.6668 7.99969 3.66663Z" />
            </mask>
            <path
                d="M7.99969 0.666626C10.0244 0.666626 11.8589 1.48794 13.1852 2.81409C14.5115 4.14037 15.3336 5.97492 15.3337 7.99963C15.3337 10.0245 14.5116 11.8588 13.1852 13.1852C11.8589 14.5115 10.0245 15.3336 7.99969 15.3336C5.97498 15.3335 4.14043 14.5115 2.81415 13.1852C1.488 11.8589 0.666687 10.0243 0.666687 7.99963C0.666775 5.97492 1.48788 4.14037 2.81415 2.81409C4.14043 1.48782 5.97498 0.666714 7.99969 0.666626ZM7.99969 1.99963C6.34281 1.99972 4.84397 2.671 3.75751 3.75745C2.67106 4.84391 1.99978 6.34274 1.99969 7.99963C1.99969 9.65666 2.67099 11.1563 3.75751 12.2428C4.84396 13.3292 6.34289 13.9995 7.99969 13.9996C9.65671 13.9996 11.1563 13.3293 12.2429 12.2428C13.3294 11.1563 13.9997 9.65665 13.9997 7.99963C13.9996 6.34283 13.3292 4.8439 12.2429 3.75745C11.1563 2.67093 9.65672 1.99963 7.99969 1.99963ZM8.16669 5.99963C8.53488 5.99963 8.83368 6.29844 8.83368 6.66663V10.6666H9.33368C9.70172 10.6668 9.99969 10.9655 9.99969 11.3336C9.99952 11.7015 9.70161 11.9995 9.33368 11.9996H6.99969C6.63176 11.9995 6.33386 11.7015 6.33368 11.3336C6.33368 10.9655 6.63165 10.6668 6.99969 10.6666H7.49969V7.33362C7.13165 7.33344 6.83368 7.03471 6.83368 6.66663C6.83368 6.29854 7.13165 5.99981 7.49969 5.99963H8.16669ZM7.99969 3.66663C8.45982 3.66663 8.8335 4.03955 8.83368 4.49963C8.83368 4.95987 8.45993 5.33362 7.99969 5.33362C7.53961 5.33344 7.16669 4.95976 7.16669 4.49963C7.16686 4.03966 7.53972 3.6668 7.99969 3.66663Z"
                fill={color}
            />
            <path
                d="M7.99969 0.666626V-0.533374H7.99964L7.99969 0.666626ZM13.1852 2.81409L14.0338 1.96556L14.0337 1.9655L13.1852 2.81409ZM15.3337 7.99963H16.5337V7.99958L15.3337 7.99963ZM13.1852 13.1852L14.0338 14.0337L14.0338 14.0337L13.1852 13.1852ZM7.99969 15.3336L7.99964 16.5336H7.99969V15.3336ZM2.81415 13.1852L1.96557 14.0337L1.96562 14.0337L2.81415 13.1852ZM0.666687 7.99963L-0.533313 7.99958V7.99963H0.666687ZM2.81415 2.81409L1.96563 1.96555L1.96561 1.96557L2.81415 2.81409ZM7.99969 1.99963V0.799634H7.99963L7.99969 1.99963ZM3.75751 3.75745L2.90899 2.90891L2.90897 2.90893L3.75751 3.75745ZM1.99969 7.99963L0.799695 7.99957V7.99963H1.99969ZM3.75751 12.2428L2.90898 13.0913L2.90902 13.0914L3.75751 12.2428ZM7.99969 13.9996L7.99963 15.1996H7.99969V13.9996ZM12.2429 12.2428L11.3943 11.3943L11.3943 11.3943L12.2429 12.2428ZM13.9997 7.99963H15.1997V7.99957L13.9997 7.99963ZM12.2429 3.75745L13.0914 2.90896L13.0914 2.90892L12.2429 3.75745ZM8.83368 6.66663H10.0337V6.66663L8.83368 6.66663ZM8.83368 10.6666H7.63368V11.8666H8.83368V10.6666ZM9.33368 10.6666L9.33425 9.46663H9.33368V10.6666ZM9.99969 11.3336L11.1997 11.3342V11.3336H9.99969ZM9.33368 11.9996V13.1996H9.33425L9.33368 11.9996ZM6.99969 11.9996L6.99912 13.1996H6.99969V11.9996ZM6.33368 11.3336H5.13368L5.13368 11.3342L6.33368 11.3336ZM6.99969 10.6666V9.46663H6.99912L6.99969 10.6666ZM7.49969 10.6666V11.8666H8.69969V10.6666H7.49969ZM7.49969 7.33362H8.69969V6.13419L7.50027 6.13362L7.49969 7.33362ZM6.83368 6.66663L5.63368 6.66663V6.66663H6.83368ZM7.49969 5.99963V4.79963L7.49912 4.79963L7.49969 5.99963ZM7.99969 3.66663V2.46663L7.99924 2.46663L7.99969 3.66663ZM8.83368 4.49963H10.0337V4.49918L8.83368 4.49963ZM7.99969 5.33362L7.99924 6.53362H7.99969V5.33362ZM7.16669 4.49963L5.96669 4.49918V4.49963H7.16669ZM7.99969 0.666626V1.86663C9.69341 1.86663 11.2263 2.55236 12.3368 3.66267L13.1852 2.81409L14.0337 1.9655C12.4915 0.423511 10.3553 -0.533374 7.99969 -0.533374V0.666626ZM13.1852 2.81409L12.3367 3.66261C13.4473 4.77323 14.1336 6.30621 14.1337 7.99969L15.3337 7.99963L16.5337 7.99958C16.5336 5.64362 15.5757 3.50751 14.0338 1.96556L13.1852 2.81409ZM15.3337 7.99963H14.1337C14.1337 9.69316 13.4474 11.2259 12.3367 12.3367L13.1852 13.1852L14.0338 14.0337C15.5758 12.4917 16.5337 10.3558 16.5337 7.99963H15.3337ZM13.1852 13.1852L12.3367 12.3367C11.226 13.4474 9.69322 14.1336 7.99969 14.1336V15.3336V16.5336C10.3559 16.5336 12.4918 15.5757 14.0338 14.0337L13.1852 13.1852ZM7.99969 15.3336L7.99975 14.1336C6.30628 14.1335 4.77329 13.4473 3.66267 12.3366L2.81415 13.1852L1.96562 14.0337C3.50757 15.5756 5.64368 16.5335 7.99964 16.5336L7.99969 15.3336ZM2.81415 13.1852L3.66273 12.3367C2.55242 11.2263 1.86669 9.69335 1.86669 7.99963H0.666687H-0.533313C-0.533313 10.3553 0.423572 12.4915 1.96557 14.0337L2.81415 13.1852ZM0.666687 7.99963L1.86669 7.99969C1.86676 6.30582 2.55237 4.77294 3.66268 3.66261L2.81415 2.81409L1.96561 1.96557C0.423399 3.50781 -0.533211 5.64402 -0.533313 7.99958L0.666687 7.99963ZM2.81415 2.81409L3.66267 3.66262C4.773 2.55231 6.30588 1.8667 7.99975 1.86663L7.99969 0.666626L7.99964 -0.533374C5.64408 -0.533272 3.50787 0.423338 1.96563 1.96555L2.81415 2.81409ZM7.99969 1.99963L7.99963 0.799634C6.01155 0.799739 4.21115 1.60677 2.90899 2.90891L3.75751 3.75745L4.60603 4.60598C5.47679 3.73523 6.67406 3.1997 7.99976 3.19963L7.99969 1.99963ZM3.75751 3.75745L2.90897 2.90893C1.60683 4.21109 0.7998 6.01149 0.799695 7.99957L1.99969 7.99963L3.19969 7.9997C3.19977 6.67399 3.73529 5.47673 4.60604 4.60597L3.75751 3.75745ZM1.99969 7.99963H0.799695C0.799695 9.98773 1.60664 11.789 2.90898 13.0913L3.75751 12.2428L4.60604 11.3943C3.73534 10.5236 3.19969 9.32559 3.19969 7.99963H1.99969ZM3.75751 12.2428L2.90902 13.0914C4.21149 14.3937 6.0121 15.1995 7.99963 15.1996L7.99969 13.9996L7.99976 12.7996C6.67368 12.7996 5.47642 12.2646 4.606 11.3942L3.75751 12.2428ZM7.99969 13.9996V15.1996C9.98729 15.1996 11.7887 14.394 13.0914 13.0913L12.2429 12.2428L11.3943 11.3943C10.524 12.2646 9.32614 12.7996 7.99969 12.7996V13.9996ZM12.2429 12.2428L13.0914 13.0913C14.3941 11.7886 15.1997 9.98723 15.1997 7.99963H13.9997H12.7997C12.7997 9.32608 12.2647 10.5239 11.3943 11.3943L12.2429 12.2428ZM13.9997 7.99963L15.1997 7.99957C15.1996 6.01204 14.3938 4.21143 13.0914 2.90896L12.2429 3.75745L11.3943 4.60594C12.2646 5.47636 12.7996 6.67362 12.7997 7.9997L13.9997 7.99963ZM12.2429 3.75745L13.0914 2.90892C11.789 1.60658 9.98779 0.799634 7.99969 0.799634V1.99963V3.19963C9.32565 3.19963 10.5236 3.73528 11.3943 4.60598L12.2429 3.75745ZM8.16669 5.99963V7.19963C7.87213 7.19963 7.63368 6.96118 7.63368 6.66663L8.83368 6.66663L10.0337 6.66663C10.0337 5.63569 9.19762 4.79963 8.16669 4.79963V5.99963ZM8.83368 6.66663H7.63368V10.6666H8.83368H10.0337V6.66663H8.83368ZM8.83368 10.6666V11.8666H9.33368V10.6666V9.46663H8.83368V10.6666ZM9.33368 10.6666L9.33311 11.8666C9.03713 11.8665 8.7997 11.6266 8.7997 11.3336H9.99969H11.1997C11.1997 10.3045 10.3663 9.46712 9.33425 9.46663L9.33368 10.6666ZM9.99969 11.3336L8.7997 11.333C8.79984 11.0387 9.03874 10.7998 9.33311 10.7996L9.33368 11.9996L9.33425 13.1996C10.3645 13.1991 11.1992 12.3644 11.1997 11.3342L9.99969 11.3336ZM9.33368 11.9996V10.7996H6.99969V11.9996V13.1996H9.33368V11.9996ZM6.99969 11.9996L7.00027 10.7996C7.29463 10.7998 7.53354 11.0387 7.53368 11.333L6.33368 11.3336L5.13368 11.3342C5.13417 12.3644 5.9689 13.1991 6.99912 13.1996L6.99969 11.9996ZM6.33368 11.3336H7.53368C7.53368 11.6266 7.29624 11.8665 7.00027 11.8666L6.99969 10.6666L6.99912 9.46663C5.96707 9.46712 5.13368 10.3045 5.13368 11.3336H6.33368ZM6.99969 10.6666V11.8666H7.49969V10.6666V9.46663H6.99969V10.6666ZM7.49969 10.6666H8.69969V7.33362H7.49969H6.2997V10.6666H7.49969ZM7.49969 7.33362L7.50027 6.13362C7.79624 6.13376 8.03368 6.37368 8.03368 6.66663H6.83368H5.63368C5.63368 7.69573 6.46707 8.53312 7.49912 8.53362L7.49969 7.33362ZM6.83368 6.66663L8.03368 6.66663C8.03368 6.95957 7.79624 7.19949 7.50027 7.19963L7.49969 5.99963L7.49912 4.79963C6.46707 4.80013 5.63368 5.63752 5.63368 6.66663L6.83368 6.66663ZM7.49969 5.99963V7.19963H8.16669V5.99963V4.79963H7.49969V5.99963ZM7.99969 3.66663V4.86663C7.79845 4.86663 7.63376 4.70377 7.63368 4.50009L8.83368 4.49963L10.0337 4.49918C10.0332 3.37533 9.12119 2.46663 7.99969 2.46663V3.66663ZM8.83368 4.49963H7.63368C7.63368 4.29713 7.79719 4.13362 7.99969 4.13362V5.33362V6.53362C9.12267 6.53362 10.0337 5.62261 10.0337 4.49963H8.83368ZM7.99969 5.33362L8.00015 4.13362C8.20383 4.1337 8.36669 4.29839 8.36669 4.49963H7.16669H5.96669C5.96669 5.62113 6.8754 6.53319 7.99924 6.53362L7.99969 5.33362ZM7.16669 4.49963L8.36669 4.50009C8.36661 4.7025 8.20256 4.86655 8.00015 4.86663L7.99969 3.66663L7.99924 2.46663C6.87688 2.46706 5.96712 3.37682 5.96669 4.49918L7.16669 4.49963Z"
                fill={color}
                mask="url(#path-1-inside-1_50_87257)"
            />
        </svg>
    );
};
